type Link = {
  name: string;
  action: string;
  url?: string;
  userRight?: string;
  path?: string;
};

type MenuItem = {
  header: string;
  links: Link[];
  icon: string;
  userRight?: string;
};

type Env = "prod" | "sandbox";

const trimSlash = (s: string) => s.replace(/\/+$/, "");

function getEnvFromUrl(): Env {
  const host =
    typeof window !== "undefined" && window.location?.hostname
      ? window.location.hostname.toLowerCase()
      : "";

  if (host.includes("sandbox")) {
    return "sandbox";
  }

  return "prod";
}

const DATA_HOST = trimSlash(
  getEnvFromUrl() === "sandbox"
    ? "https://data.sandbox.westernbulk.cloud"
    : "https://data.prod.westernbulk.cloud",
);

const NAVILEXT_HOST = trimSlash(
  getEnvFromUrl() === "sandbox"
    ? "https://sandbox.navi-lex.com"
    : "https://prod.navi-lex.com",
);

const WB_WEBPAGES = `${DATA_HOST}/wb-webpages/src/main.html?page=`;
const NAVILEX_PAGE = (page: string) =>
  `${NAVILEXT_HOST}/?page=${encodeURIComponent(page)}`;

export const sidebarLinks: MenuItem[] = [
  {
    header: "TONNAGE",
    icon: "bi bi-life-preserver",
    links: [
      {
        name: "-VESSELVIEW",
        action: "vessel-view",
      },
    ],
  },
  {
    header: "WEATHER",
    icon: "bi bi-cloud-sun",
    links: [
      {
        name: "-PORTS",
        action: "weather-in-ports",
      },
      {
        name: "-SEA MARGIN",
        action: "sea-margin",
      },
    ],
  },
  {
    header: "EMISSIONS",
    icon: "bi bi-thermometer",
    links: [
      {
        name: "-VOYAGE CO2",
        action: "emission-report",
      },
      {
        name: "-EU REPORTS",
        action: "eu-ets-report",
      },
    ],
  },
  {
    header: "TRADES",
    userRight: "tradeRecap",
    icon: "bi bi-currency-dollar",
    links: [
      {
        name: "-STRATEGIES",
        action: "fdtr-strategies",
      },
      {
        name: "-RECAP MANAGER",
        action: "recap-manager",
      },
    ],
  },
  {
    header: "VENTURA",
    icon: "bi bi-clipboard-data-fill",
    links: [
      {
        name: "-PORT DATA",
        action: "ventura-port",
      },
      // {
      //   name: "-VENTURA UPDATED",
      //   action: "ventura-updated",
      // },
    ],
  },
  {
    userRight: "navilex-admin",
    header: "ADMIN",
    icon: "bi bi-gear",
    links: [
      //{ name: "-CONTRACT TYPES", action: "contract-admin",userRight:"navilex-admin" },
      { name: "-TOKEN", action: "token", userRight: "navilex-admin-token" },
      { name: "-DIRECTORY", action: "directory" },
    ],
  },
  {
    header: "ANALYTICS",
    icon: "bi bi-bar-chart-line",
    links: [
      {
        name: "-TEAM ESTIMATES",
        action: "team-estimates",
      },
      // Additional links
    ],
  },
  {
    header: "OFFICE TOOLS",
    userRight: "businessCard",
    icon: "bi bi-card-list",
    links: [
      {
        name: "-BUSINESS CARD",
        action: "business-card",
      },
      // Additional links
    ],
  },
  {
    header: "FILE SHARING",
    userRight: "file_sharing",
    icon: "bi bi-folder-symlink",
    links: [
      {
        name: "-SHARE FILES",
        action: "file-sharing",
      },
    ],
  },
  {
    header: "NAVILEX AI",
    icon: "bi bi-journal-bookmark-fill",
    links: [
      {
        name: "-NEW CONTRACT",
        action: "link",
        url: NAVILEX_PAGE("new-contract"),
      },
      {
        name: "-CONTRACT HISTORY",
        action: "link",
        url: NAVILEX_PAGE("workflows"),
      },
    ],
  },
  {
    header: "FDTR",
    userRight: "tradeRecap",
    icon: "bi bi-infinity",
    links: [
      { name: "-DASHBOARD", action: "ffa-overview" },
      {
        name: "-SEASONALITY",
        action: "seasonality",
      },
    ],
  },
  // Add more sections as needed
];
